export default __webpack_public_path__ + "static/waxsettingwithdifferentmeasurements-c85ea3365aa304b89bfc552160aea2eb.png";